import axios from 'axios';

export default {
	getPublications(year) {
		return axios.get('/apps05/capital-market/api/getPublications', { params: { siteId: '1', year } });
	}
};
